export default __webpack_public_path__ + "static/media/kick-credit-payment-success.9c0167fb.jpg";